import React from 'react';
import { CONF_FORMAT } from '../../../../constants/Labels';
class FormatSettings extends React.Component {
  constructor(props) {
    super(props);
    this.section = 'overlays';
    // eslint-disable-next-line react/no-unused-class-component-methods
    this.invalidFileds = [];
  }
  render() {
    return (
      <div className="pluginSettingsSection" id={this.section}>
        <div
          className="placementDescription"
          onClick={e => this.props.toggleElement(e, '.settingsInputs')}
        >
          <div className="pluginSectionsTitle formatTitle">Format Settings</div>
        </div>
        <div className="settingsInputs">
          <div
            className="settingsDescription description"
            dangerouslySetInnerHTML={{ __html: CONF_FORMAT }}
          ></div>
          <div className="inputsRow">
            <div className="labelHolder">
              <div className="smallInput">
                <label>Hide when content pause</label>
              </div>
              <div className="smallInput">
                <label>Resize</label>
              </div>
            </div>
            <div className="smallInput">
              <p>
                <input
                  type="radio"
                  key={this.props.overlays.hideDuringPause}
                  name="hideDuringPause"
                  id="hideDuringPause0"
                  defaultValue={true}
                  defaultChecked={this.props.overlays.hideDuringPause === true}
                  onClick={e => this.props.handleOptionChange(e, this, Boolean)}
                />
                <label htmlFor="hideDuringPause0">True</label>
              </p>
              <p>
                <input
                  type="radio"
                  key={!this.props.overlays.hideDuringPause}
                  name="hideDuringPause"
                  id="hideDuringPause1"
                  defaultValue={false}
                  defaultChecked={this.props.overlays.hideDuringPause === false}
                  onClick={e => this.props.handleOptionChange(e, this, Boolean)}
                />
                <label htmlFor="hideDuringPause1">False</label>
              </p>
            </div>
            <div className="smallInput">
              <p>
                <input
                  type="radio"
                  key={this.props.overlays.resize}
                  name="resize"
                  id="resize0"
                  defaultValue={true}
                  defaultChecked={this.props.overlays.resize === true}
                  onClick={e => this.props.handleOptionChange(e, this, Boolean)}
                />
                <label htmlFor="resize0">True</label>
              </p>
              <p>
                <input
                  type="radio"
                  key={!this.props.overlays.resize}
                  name="resize"
                  id="resize1"
                  defaultValue={false}
                  defaultChecked={this.props.overlays.resize === false}
                  onClick={e => this.props.handleOptionChange(e, this, Boolean)}
                />
                <label htmlFor="resize1">False</label>
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default FormatSettings;
